import React, { FC } from 'react';
import { Router } from '@reach/router';
import i18next from 'i18next';

import { ErrorBoundary } from '../components/ErrorBoundary';
import { CLIENT_PATHS } from '../services/checkout-service/axiosInstance';
import { Checkout } from './Checkout';
import { PageNotFound } from './PageNotFound';
import { CheckoutDetails } from './Checkout/CheckoutDetails';
import { Confirmation } from './Checkout/Confirmation';
import { PageLayout } from '../components/PageLayout';
import { Header } from '../components/PageLayout/Header';
import { Banner } from '../components/Banner';
import { CheckoutDetailsShimmer } from './Checkout/CheckoutDetails/CheckoutDetailsShimmer';

import styles from './App.module.scss';

const fallback = (error?: Error) => (
  <PageLayout hideFooter={true} customMainClass={styles.main} header={<Header className={styles.header} />}>
    <Banner className={styles.banner}>
      <p>{error?.message ? error.message : i18next.t('genericError')}</p>
    </Banner>
    <CheckoutDetailsShimmer hideHeader={true} />
  </PageLayout>
);

const App: FC = () => (
  <ErrorBoundary fallback={fallback}>
    {CLIENT_PATHS.map((basePath, index) => (
      <Router key={index} basepath={basePath} data-testid="app">
        <PageNotFound path="not-found" />
        <Checkout path=":checkoutSessionId">
          <CheckoutDetails path="/*" />
          <Confirmation path="confirmation/*" />
        </Checkout>
      </Router>
    ))}
  </ErrorBoundary>
);

export { App };
